//get all receipt maintenance data
export const RECEIPT_MAINTENANCE_REQUEST = "RECEIPT_MAINTENANCE_REQUEST";
export const RECEIPT_MAINTENANCE_SUCCESS = "RECEIPT_MAINTENANCE_SUCCESS";
export const RECEIPT_MAINTENANCE_FAIL = "RECEIPT_MAINTENANCE_FAIL";

export const RECEIPT_MAINTENANCE_CLEAR_ERROR = "RECEIPT_MAINTENANCE_CLEAR_ERROR";
